/* eslint-disable ember/no-computed-properties-in-native-classes */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type Field from '@linc-technologies/linced-common/models/enrolments/field';
import { filterBy, mapBy } from '@linc-technologies/linced-common/utils/arrays';

// Proto: enrolments.Section.
export default class Section extends Fragment {
  declare [Type]: 'enrolments/section';

  // index is the order in which the section should be sorted/displayed.
  @attr('number', { defaultValue: 0 })
  declare index: number;

  // title is the the name given to the section, for example, 'Basic Details'
  @attr('string', { defaultValue: '' })
  declare title: string;

  // description provides a place for schools to explain why they need the following sections information.
  @attr('string', { defaultValue: '' })
  declare description: string;

  // fields contains all the form inputs for a given section.
  @fragmentArray('enrolments/field')
  declare fields: FragmentArray<Field>;

  // fieldIds extracts a comma-delimited list of the IDs from the fields within this section.
  @computed('fields.@each.fieldId')
  get fieldIds() {
    return mapBy(this.fields, 'fieldId').join(',');
  }

  // keyedFields contains the fields that have a key. Use it to copy values by
  // key: a field with no key makes the paths `fields.` and `.value`.
  @computed('fields.@each.key')
  get keyedFields(): Field[] {
    return filterBy(this.fields, 'key');
  }

  // count determines the number of repetitions for contact fields, if this is a contact section.
  @attr('number', { defaultValue: 0 })
  declare count: number;

  // includeBillPayer is used by contact sections to determine whether to show the bill payer flag.
  @attr('boolean', { defaultValue: false })
  declare includeBillPayer: boolean;
}
